import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import type { Banco, SalvarBancoRequest } from '../types';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (data: SalvarBancoRequest) => void;
  editingBanco?: Banco | null;
  isLoading?: boolean;
}

export const BancoDialog = ({ open, onOpenChange, onSubmit, editingBanco, isLoading }: Props) => {
  const form = useForm<SalvarBancoRequest>({
    defaultValues: { codigoBanco: '', descricao: '' },
  });

  useEffect(() => {
    if (editingBanco) {
      form.reset({ codigoBanco: editingBanco.codigoBanco, descricao: editingBanco.descricao });
    } else {
      form.reset({ codigoBanco: '', descricao: '' });
    }
  }, [editingBanco, open, form]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[400px]">
        <DialogHeader>
          <DialogTitle>{editingBanco ? 'Editar Banco' : 'Novo Banco'}</DialogTitle>
        </DialogHeader>
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
            <FormField
              control={form.control}
              name="codigoBanco"
              rules={{ required: 'Código é obrigatório' }}
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Código do Banco *</FormLabel>
                  <FormControl>
                    <Input placeholder="Ex: 001, 341" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="descricao"
              rules={{ required: 'Nome é obrigatório' }}
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Nome do Banco *</FormLabel>
                  <FormControl>
                    <Input placeholder="Ex: Banco do Brasil" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <DialogFooter>
              <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
              <Button type="submit" disabled={isLoading}>
                {isLoading ? 'Salvando...' : editingBanco ? 'Atualizar' : 'Criar'}
              </Button>
            </DialogFooter>
          </form>
        </Form>
      </DialogContent>
    </Dialog>
  );
};
